import { render, staticRenderFns } from "./TitleBorder.vue?vue&type=template&id=21bff140&scoped=true"
import script from "./TitleBorder.vue?vue&type=script&lang=js"
export * from "./TitleBorder.vue?vue&type=script&lang=js"
import style0 from "./TitleBorder.vue?vue&type=style&index=0&id=21bff140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bff140",
  null
  
)

export default component.exports